import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import { initBrowserFeatures } from './utils/browserFeatures'
import { initializeSentry } from './integrations/sentry'

// Initialize browser features to suppress unwanted warnings
initBrowserFeatures();
// Initialize error monitoring (no-op if DSN not set)
initializeSentry();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
)
